module.exports = __webpack_public_path__ + "img/kasen ibaraki_sc1.53ca1b23.png";